function getSuspendState(state) {
  return {
    isLoading: state.suspend.loading,
    fetchResponse: state.suspend.data,
    recievedSuccessfulResponse: state.suspend.recievedSuccessfulResponse,
    recievedErrorResponse: state.suspend.recievedErrorResponse,
    currentPosting: state.suspend.currentPosting,
    isParticularNotFree: state.suspend.isParticularNotFree,
    bulkSuccessful: state.suspend.bulkSuccessful,
    bulkError: state.suspend.bulkError
  };
}

export { getSuspendState };
